module.exports = __webpack_public_path__ + "static/media/DNA-based-Level01.fb4652c6.svg";